module.exports = __webpack_public_path__ + "static/media/investment-avax.1fbbd996.svg";